import { Docs } from "@pcgerente-node/pcg-comun";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { obtenerRangoGuiaDelUsuario } from "../../../../redux/actions/actionsCrear";
import { RootState, useAppDispatch } from "../../../../redux/store";
import { ChildProps_logistica_GUIA_PROFORMAviewModel } from "../ContentGuia";



const NumeroGuia: React.FC<ChildProps_logistica_GUIA_PROFORMAviewModel> = ({vm, guia, setGuia}) => {

  const usuarioVM = useSelector((state: RootState) => state.auth.usuarioActual)
  const infoRangoGuiaStore = useSelector((state: RootState) => state.crear.rangoGuia)
  const rangoGuiaStore = infoRangoGuiaStore.info
  
  const dispatch = useAppDispatch()
  
  useEffect(() =>{
      dispatch(obtenerRangoGuiaDelUsuario(usuarioVM._ItemActivo.id, Docs.GUIA_TRANSPORTE))
  }, [guia.serie1 === ""])
  
  useEffect(() => {
    if(rangoGuiaStore.id>0){
         vm.EstablecerRango(rangoGuiaStore, guia, setGuia)
      }
  },[rangoGuiaStore])
  return (
    usuarioVM.loading === false?
      !usuarioVM.error?
        <h3 style={{color: "orangered"}}>Guía # {ObtenerNumeroRangoCompleto()}</h3>
      :<h3 className="mt-4 text-danger p-4">{usuarioVM.error}</h3>
    :<h3 style={{color: "orangered"}}>
      Cargando...
    </h3>
  );
  function  ObtenerNumeroRangoCompleto():string{
    if(guia){
      return `${guia.serie1}-${guia.serie2}-${guia.numeroDocumento}` 
    }else{
      return ""
    }
  }
};

export default NumeroGuia;
